// Web stand-in for @react-native-google-signin/google-signin.
//
// Aliased in place of the real package for the web bundle only (see
// webpack.config.web.js resolve.alias) — the native package has no web
// build and would fail to resolve/initialize in a browser. This keeps
// useAuth.ts and ProfileScreen.tsx (both of which import the real package
// directly) importable on web without any changes to either file.
//
// Phase 0 intentionally does NOT implement Google sign-in on web (that's a
// later phase, using Firebase's own signInWithPopup/signInWithRedirect +
// GoogleAuthProvider). Calling into this stub surfaces a clear, visible
// error instead of silently pretending to succeed.
const NOT_SUPPORTED_MESSAGE =
  '[Tonyte][Web] Google Sign-In is not implemented on web yet (Phase 0). It will use Firebase signInWithPopup in a later phase.';

export const GoogleSignin = {
  configure(_options?: Record<string, unknown>) {
    // no-op on web
  },
  async hasPlayServices(_options?: { showPlayServicesUpdateDialog: boolean }): Promise<boolean> {
    return false;
  },
  async signIn(): Promise<never> {
    throw new Error(NOT_SUPPORTED_MESSAGE);
  },
  async getTokens(): Promise<never> {
    throw new Error(NOT_SUPPORTED_MESSAGE);
  },
  async signOut(): Promise<void> {
    // no-op on web
  },
};

export default { GoogleSignin };
